<template>
    <div class="dots flex flex-col">
        <div></div>
        <div></div>
        <div></div>
    </div>
</template>

<script>
export default {
	name: "DotsVertical"
};
</script>

<style scoped lang="scss">
.dots {
    --gap-small: 13px;
    --gap-normal: 16px;
    --gap-big: 19px;
    --dot-size: 12px;

    @media (min-width: 1024px) {
        --gap-small: 15px;
        --gap-normal: 25px;
        --gap-big: 40px;
        --dot-size: 22px;
        animation: move 10s alternate infinite ease-in-out;
    }

    gap: var(--gap-normal);
    animation: move 3s alternate infinite ease-in-out;

    & > div {
        width: var(--dot-size);
        height: var(--dot-size);
        background: var(--green);
        border-radius: 50%;
    }

    @keyframes move {
        0% {
            gap: var(--gap-small)
        }
        100% {
            gap: var(--gap-big);
        }
    }
}
</style>
